export const entityFields = {
    earnings_conference: {
        nonEntityes: ['company_name', 'status', 'time_zone', 'financial_quarter', 'title', 'live_phone_us', 'live_passcode_us', 'live_phone_international', 'live_passcode_international', 'replay_phone_us', 'replay_passcode_us',
            'replay_phone_international', 'replay_passcode_international', 'registration_phone', 'registration_passcode', 'live_webcast_url', 'financial_year', 'replay_webcast_url', 'comments', 'period_end_date', 'announcement_date', 'event_date', 'event_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'event_date', cmd: 'event_date' }],
        TIME: [{ title: 'event_time', cmd: 'event_time' }]
    },
    analyst_or_investor_conference: {
        nonEntityes: ['company_name', 'status', 'time_zone', 'financial_quarter', 'title', 'live_phone_us', 'live_passcode_us', 'live_phone_international', 'live_passcode_international', 'replay_phone_us', 'replay_passcode_us',
            'replay_phone_international', 'replay_passcode_international', 'registration_phone', 'registration_passcode', 'live_webcast_url', 'financial_year', 'replay_webcast_url', 'comments', 'period_end_date', 'announcement_date', 'event_date', 'event_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'event_date', cmd: 'event_date' }],
        TIME: [{ title: 'event_time', cmd: 'event_time' }]
    },
    annual_general_meeting_conference: {
        nonEntityes: ['company_name', 'status', 'event_description', 'time_zone', 'financial_quarter', 'title', 'live_phone_us', 'live_passcode_us', 'live_phone_international', 'live_passcode_international', 'replay_phone_us', 'replay_passcode_us',
            'replay_phone_international', 'replay_passcode_international', 'registration_phone', 'registration_passcode', 'live_webcast_url', 'financial_year', 'replay_webcast_url', 'event_link', 'registration_link', 'schedule_link', 'comments', 'period_end_date', 'announcement_date', 'event_date', 'event_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'event_date', cmd: 'event_date' }],
        TIME: [{ title: 'event_time', cmd: 'event_time' }]
    },
    earnings_announcement_release: {
        nonEntityes: ['company_name', 'title', 'time_zone', 'release_segment', 'financial_quarter', 'financial_year', 'comments', 'release_date', 'announcement_date', 'period_end_date', 'release_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'release_date', cmd: 'release_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'period_end_date', cmd: 'period_end_date' }],
        TIME: [{ title: 'release_time', cmd: 'release_time' }]
    },
    sales_or_revenue_release: {
        nonEntityes: ['company_name', 'title', 'time_zone', 'release_segment', 'financial_quarter', 'financial_year', 'comments', 'release_date', 'announcement_date', 'period_end_date', 'release_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'release_date', cmd: 'release_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'period_end_date', cmd: 'period_end_date' }],
        TIME: [{ title: 'release_time', cmd: 'release_time' }]
    },
    sales_or_revenue_conference: {
        nonEntityes: ['company_name', 'status', 'time_zone', 'financial_quarter', 'title', 'live_phone_us', 'live_passcode_us', 'live_phone_international', 'live_passcode_international', 'replay_phone_us', 'replay_passcode_us',
            'replay_phone_international', 'replay_passcode_international', 'registration_phone', 'registration_passcode', 'live_webcast_url', 'financial_year', 'replay_webcast_url', 'comments', 'period_end_date', 'announcement_date', 'event_date', 'event_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'event_date', cmd: 'event_date' }],
        TIME: [{ title: 'event_time', cmd: 'event_time' }]
    },
    corporate_conference: {
        nonEntityes: ['company_name', 'status', 'time_zone', 'financial_quarter', 'title', 'live_phone_us', 'live_passcode_us', 'live_phone_international', 'live_passcode_international', 'replay_phone_us', 'replay_passcode_us',
            'replay_phone_international', 'replay_passcode_international', 'registration_phone', 'registration_passcode', 'live_webcast_url', 'financial_year', 'replay_webcast_url', 'comments', 'period_end_date', 'announcement_date', 'event_date', 'event_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'event_date', cmd: 'event_date' }],
        TIME: [{ title: 'event_time', cmd: 'event_time' }]
    },
    guidance_conference: {
        nonEntityes: ['company_name', 'status', 'time_zone', 'financial_quarter', 'title', 'live_phone_us', 'live_passcode_us', 'live_phone_international', 'live_passcode_international', 'replay_phone_us', 'replay_passcode_us',
            'replay_phone_international', 'replay_passcode_international', 'registration_phone', 'registration_passcode', 'live_webcast_url', 'financial_year', 'replay_webcast_url', 'comments', 'period_end_date', 'announcement_date', 'event_date', 'event_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'event_date', cmd: 'event_date' }],
        TIME: [{ title: 'event_time', cmd: 'event_time' }]
    },
    special_or_m_and_a_conference: {
        nonEntityes: ['company_name', 'status', 'time_zone', 'financial_quarter', 'title', 'live_phone_us', 'live_passcode_us', 'live_phone_international', 'live_passcode_international', 'replay_phone_us', 'replay_passcode_us',
            'replay_phone_international', 'replay_passcode_international', 'registration_phone', 'registration_passcode', 'live_webcast_url', 'financial_year', 'replay_webcast_url', 'comments', 'period_end_date', 'announcement_date', 'event_date', 'event_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'event_date', cmd: 'event_date' }],
        TIME: [{ title: 'event_time', cmd: 'event_time' }]
    },
    product_release: {
        nonEntityes: ['company_name', 'time_zone', 'release_segment', 'financial_quarter', 'financial_year',
            'title', 'comments', 'period_end_date', 'announcement_date', 'release_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }],
        TIME: [{ title: 'release_time', cmd: 'release_time' }]
    },
    management_update_release: {
        nonEntityes: ['company_name', 'time_zone', 'release_segment', 'financial_quarter', 'financial_year',
            'title', 'comments', 'period_end_date', 'announcement_date', 'release_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }],
        TIME: [{ title: 'release_time', cmd: 'release_time' }]
    },
    m_and_a_release: {
        nonEntityes: ['company_name', 'time_zone', 'release_segment', 'financial_quarter', 'financial_year',
            'title', 'comments', 'period_end_date', 'announcement_date', 'release_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }],
        TIME: [{ title: 'release_time', cmd: 'release_time' }]
    },
    earnings_release: {
        nonEntityes: ['company_name', 'time_zone', 'release_segment', 'financial_quarter', 'financial_year',
            'title', 'comments', 'period_end_date', 'announcement_date', 'release_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }],
        TIME: [{ title: 'release_time', cmd: 'release_time' }]
    },
    other_releases: {
        nonEntityes: ['company_name', 'time_zone', 'release_segment', 'financial_quarter', 'financial_year',
            'title', 'comments', 'period_end_date', 'announcement_date', 'release_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }],
        TIME: [{ title: 'release_time', cmd: 'release_time' }]
    },
    forecasted_earnings_release_date: {
        nonEntityes: ['company_name', 'time_zone', 'release_segment', 'financial_quarter', 'financial_year', 'earnings_date_status', 'comments', 'period_end_date', 'projected_release_date', 'projected_release_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'projected_release_date', cmd: 'projected_release_date' }],
        TIME: [{ title: 'projected_release_time', cmd: 'projected_release_time' }]
    },
    earnings_release_date_change: {
        nonEntityes: ['company_name', 'time_zone', 'status', 'release_segment', 'financial_quarter', 'financial_year', 'status', 'comments', 'period_end_date', 'announcement_date', 'revised_earnings_release_date', 'revised_earnings_release_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'period_end_date', cmd: 'period_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'revised_earnings_release_date', cmd: 'revised_earnings_release_date' }],
        TIME: [{ title: 'revised_earnings_release_time', cmd: 'revised_earnings_release_time' }]
    },
    capital_markets_day: {
        nonEntityes: ['company_name', 'event_organizer', 'event_description', 'status', 'time_zone', 'venue', 'address', 'city', 'state', 'country', 'event_link', 'registration_link', 'schedule_link', 'comments',
            'start_date', 'announcement_date', 'end_date', 'start_time', 'end_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'start_date', cmd: 'start_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'end_date', cmd: 'end_date' }],
        TIME: [{ title: 'start_time', cmd: 'start_time' }, { title: 'end_time', cmd: 'end_time' }]
    },
    r_and_d_day: {
        nonEntityes: ['company_name', 'event_organizer', 'event_description', 'status', 'time_zone', 'venue', 'address', 'city', 'state', 'country', 'event_link', 'registration_link', 'schedule_link', 'comments',
            'start_date', 'announcement_date', 'end_date', 'start_time', 'end_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'start_date', cmd: 'start_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'end_date', cmd: 'end_date' }],
        TIME: [{ title: 'start_time', cmd: 'start_time' }, { title: 'end_time', cmd: 'end_time' }]
    },
    company_roadshow: {
        nonEntityes: ['company_name', 'event_organizer', 'event_description', 'status', 'time_zone', 'venue', 'address', 'city', 'state', 'country', 'event_link', 'registration_link', 'schedule_link', 'comments',
            'start_date', 'announcement_date', 'end_date', 'start_time', 'end_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'start_date', cmd: 'start_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'end_date', cmd: 'end_date' }],
        TIME: [{ title: 'start_time', cmd: 'start_time' }, { title: 'end_time', cmd: 'end_time' }]
    },
    business_update_call: {
        nonEntityes: ['company_name', 'status', 'time_zone', 'financial_quarter', 'financial_year', 'event_description', 'live_phone_us', 'live_passcode_us', 'live_phone_international', 'live_passcode_international', 'replay_phone_us',
            'replay_passcode_us', 'replay_phone_international', 'replay_passcode_international', 'registration_phone', 'registration_passcode',
            'live_webcast_url', 'replay_webcast_url', 'comments', 'event_date', 'event_time', 'announcement_date', 'period_end_date', 'replay_beginning_date', 'replay_end_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'event_date', cmd: 'event_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'period_end_date', cmd: 'period_end_date' }, { title: 'replay_beginning_date', cmd: 'replay_beginning_date' }, { title: 'replay_end_date', cmd: 'replay_end_date' }],
        TIME: [{ title: 'event_time', cmd: 'event_time' }]
    },
    board_meeting: {
        nonEntityes: ['company_name', 'status', 'agenda', 'time_zone', 'comments', 'start_date', 'announcement_date', 'announcement_date', 'end_date', 'event_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'start_date', cmd: 'start_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'end_date', cmd: 'end_date' }],
        TIME: [{ title: 'event_time', cmd: 'event_time' }]
    },
    comp_store_sales_release: {
        nonEntityes: ['company_name', 'release_segment', 'time_period', 'time_zone', 'financial_year', 'calendar_year', 'comments', 'event_date', 'announcement_date', 'period_end_date', 'event_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'event_date', cmd: 'event_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'period_end_date', cmd: 'period_end_date' }],
        TIME: [{ title: 'event_time', cmd: 'event_time' }]
    },
    index_change: {
        nonEntityes: ['company_name', 'change_status', 'index', 'company_name_added', 'company_name_removed', 'comments', 'effective_date', 'announcement_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'effective_date', cmd: 'effective_date' }, { title: 'announcement_date', cmd: 'announcement_date' }],
        TIME: null
    },
    seminar: {
        nonEntityes: ['company_name', 'seminar_name', 'event_organizer', 'event_description', 'status', 'time_zone', 'registration_deadline', 'venue', 'address', 'city', 'state', 'country', 'event_link', 'registration_link',
            'schedule_link', 'seminar_passcode', 'contact_person_name', 'designation', 'phone_number', 'email', 'event_start_date', 'announcement_date', 'event_end_date', 'event_start_time', 'event_end_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'event_start_date', cmd: 'event_start_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'event_end_date', cmd: 'event_end_date' }, { title: 'registration_deadline', cmd: 'registration_deadline' }],
        TIME: [{ title: 'event_start_time', cmd: 'event_start_time' }, { title: 'event_end_time', cmd: 'event_end_time' }]
    },
    summit_meeting: {
        nonEntityes: ['company_name', 'summit_name', 'event_organizer', 'event_description', 'status', 'time_zone', 'registration_deadline', 'venue', 'address', 'city', 'state', 'country', 'event_link', 'registration_link',
            'schedule_link', 'seminar_passcode', 'contact_person_name', 'designation', 'phone_number', 'email', 'event_start_date', 'announcement_date', 'event_end_date', 'event_start_time', 'event_end_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'event_start_date', cmd: 'event_start_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'event_end_date', cmd: 'event_end_date' }, { title: 'registration_deadline', cmd: 'registration_deadline' }],
        TIME: [{ title: 'event_start_time', cmd: 'event_start_time' }, { title: 'event_end_time', cmd: 'event_end_time' }]
    },
    work_shop: {
        nonEntityes: ['company_name', 'work_shop_name', 'event_organizer', 'event_description', 'status', 'time_zone', 'registration_deadline', 'venue', 'address', 'city', 'state', 'country', 'event_link', 'registration_link',
            'schedule_link', 'seminar_passcode', 'contact_person_name', 'designation', 'phone_number', 'email', 'event_start_date', 'announcement_date', 'event_end_date', 'event_start_time', 'event_end_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'event_start_date', cmd: 'event_start_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'event_end_date', cmd: 'event_end_date' }, { title: 'registration_deadline', cmd: 'registration_deadline' }],
        TIME: [{ title: 'event_start_time', cmd: 'event_start_time' }, { title: 'event_end_time', cmd: 'event_end_time' }]
    },
    forum: {
        nonEntityes: ['company_name', 'forum_name', 'event_organizer', 'event_description', 'status', 'time_zone', 'registration_deadline', 'venue', 'address', 'city', 'state', 'country', 'event_link', 'registration_link',
            'schedule_link', 'seminar_passcode', 'contact_person_name', 'designation', 'phone_number', 'email', 'event_start_date', 'announcement_date', 'event_end_date', 'event_start_time', 'event_end_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'event_start_date', cmd: 'event_start_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'event_end_date', cmd: 'event_end_date' }, { title: 'registration_deadline', cmd: 'registration_deadline' }],
        TIME: [{ title: 'event_start_time', cmd: 'event_start_time' }, { title: 'event_end_time', cmd: 'event_end_time' }]
    },
    trade_show: {
        nonEntityes: ['company_name', 'trade_show_name', 'event_organizer', 'event_description', 'status', 'time_zone', 'registration_deadline', 'venue', 'address', 'city', 'state', 'country', 'event_link', 'registration_link',
            'schedule_link', 'seminar_passcode', 'contact_person_name', 'designation', 'phone_number', 'email', 'event_start_date', 'announcement_date', 'event_end_date', 'event_start_time', 'event_end_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'event_start_date', cmd: 'event_start_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'event_end_date', cmd: 'event_end_date' }, { title: 'registration_deadline', cmd: 'registration_deadline' }],
        TIME: [{ title: 'event_start_time', cmd: 'event_start_time' }, { title: 'event_end_time', cmd: 'event_end_time' }]
    },
    share_buyback: {
        nonEntityes: ['company_name', 'record_type', 'buy_back_status', 'buy_back_method', 'no_of_authorized_shares', 'authorized_share_value','share_value_currency', 'low_end_price_range', 'high_end_price_range', 'purchase_price', 'comments',
            'modification_announcement_date', 'announcement_date', 'approval_date', 'buy_back_end_date', 'tender_expiration_date', 'tender_expiration_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'modification_announcement_date', cmd: 'modification_announcement_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'approval_date', cmd: 'approval_date' }, { title: 'buy_back_end_date', cmd: 'buy_back_end_date' }, { title: 'tender_expiration_date', cmd: 'tender_expiration_date' }],
        TIME: [{ title: 'tender_expiration_time', cmd: 'tender_expiration_time' }]
    },
    shareholder_meeting: {
        nonEntityes: ['company_name', 'meeting_type', 'meeting_description', 'status', 'time_zone',
            'venue', 'address', 'city', 'state', 'country', 'virtual_shareholder_meeting', 'distance_between_head_quarters_and_venue',
            'registration_link', 'schedule_link', 'comments', 'record_date', 'announcement_date', 'start_date', 'end_date', 'start_time'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'record_date', cmd: 'record_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'start_date', cmd: 'start_date' }, { title: 'end_date', cmd: 'end_date' }],
        TIME: [{ title: 'start_time', cmd: 'start_time' }]
    },
    spinoff: {
        nonEntityes: ['company_name', 'transaction_status', 'parent_company_shares_cutoff', 'spin_off_company_shares_received', 'taxable', 'fractional_payment_type', 'estimated_market_cap', 'comments',
            'record_date', 'announcement_date', 'distribution_date', 'trade_date', 'approval_date', 'parent_company_trading_when_issued_from_date', 'parent_company_trading_when_issued_to_date', 'spin_off_company_trading_when_issued_from_date',
            'spin_off_company_trading_when_issued_to_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'record_date', cmd: 'record_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'distribution_date', cmd: 'distribution_date' }, { title: 'trade_date', cmd: 'trade_date' }, { title: 'approval_date', cmd: 'approval_date' }, { title: 'parent_company_trading_when_issued_from_date', cmd: 'parent_company_trading_when_issued_from_date' },
            , { title: 'parent_company_trading_when_issued_to_date', cmd: 'parent_company_trading_when_issued_to_date' }
            , { title: 'spin_off_company_trading_when_issued_from_date', cmd: 'spin_off_company_trading_when_issued_from_date' },
            , { title: 'spin_off_company_trading_when_issued_to_date', cmd: 'spin_off_company_trading_when_issued_to_date' },
        ],
        TIME: null
    },
    stock_split: {
        nonEntityes: ['company_name', 'stock_split_type', 'stock_split_status', 'split_ratio', 'comments', 'revised_stock_trading_date', 'announcement_date', 'record_date', 'split_effective_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'revised_stock_trading_date', cmd: 'revised_stock_trading_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'record_date', cmd: 'record_date' }, { title: 'split_effective_date', cmd: 'split_effective_date' }],
        TIME: null
    },
    dividend_update: {
        nonEntityes: ['company_name', 'dividend_amount', 'currency', 'frequency', 'financial_quarter', 'financial_year', 'dividend_trend', 'comments', 'ex_dividend_date', 'announcement_date', 'record_date', 'pay_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'ex_dividend_date', cmd: 'ex_dividend_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'record_date', cmd: 'record_date' }, { title: 'pay_date', cmd: 'pay_date' }],
        TIME: null
    },
    dividend_suspended_or_resumed: {
        nonEntityes: ['company_name', 'dividend_status', 'dividend_amount', 'currency', 'frequency', 'financial_quarter', 'financial_year', 'dividend_trend', 'comments', 'suspended_or_resumed_date', 'ex_dividend_date', 'announcement_date', 'record_date', 'pay_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'suspended_or_resumed_date', cmd: 'suspended_or_resumed_date' }, { title: 'ex_dividend_date', cmd: 'ex_dividend_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'record_date', cmd: 'record_date' }, { title: 'pay_date', cmd: 'pay_date' }],
        TIME: null
    },
    legal_or_lawsuit_update: {
        nonEntityes: ['company_name', 'lawsuit_category', 'lawsuit_stage', 'lawsuit_description', 'plaintiff_name', 'plaintiff_email',
            'plaintiff_address', 'plaintiff_phone_no', 'lawfirm_name', 'lawfirm_url', 'motion_dead_line', 'comments', 'class_action_start_date', 'class_action_end_date', 'announcement_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'class_action_start_date', cmd: 'class_action_start_date' }, { title: 'class_action_end_date', cmd: 'class_action_end_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'motion_dead_line', cmd: 'motion_dead_line' }],
        TIME: null
    },
    ipos: {
        nonEntityes: ['company_name', 'ipos_status', 'share_price', 'shares_offered', 'offer_amount', 'low_end_share_price', 'high_end_share_price', 'lead_managers', 'comments', 'filling_date', 'offering_date', 'announcement_date', 'quiet_period', 'lockup_period'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'filling_date', cmd: 'filling_date' }, { title: 'offering_date', cmd: 'offering_date' }, { title: 'announcement_date', cmd: 'announcement_date' }, { title: 'quiet_period', cmd: 'quiet_period' }, { title: 'lockup_period', cmd: 'lockup_period' }],
        TIME: null
    },
    secondary_offering: {
        nonEntityes: ['company_name', 'offering_status', 'selling_shareholder', 'number_of_shares_for_sale', 'share_price', 'currency', 'proceeds_received_by_company', 'under_writing_manager', 'prospectus_link', 'comments',
            'effective_date', 'closing_date', 'announcement_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'effective_date', cmd: 'effective_date' }, { title: 'closing_date', cmd: 'closing_date' }, { title: 'announcement_date', cmd: 'announcement_date' }],
        TIME: null
    },
    guidance_update: {
        nonEntityes: ['company_name', 'financial_quarter', 'financial_year', 'preliminary_guidance', 'guidance_status', 'guidance_period',
            'guidance_quarter', 'guidance_financial_year', 'revenue_range', 'eps_range', 'ebitda_range', 'capital_expenditures', 'operating_expenses',
            'outlook_info', 'comments', 'announcement_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'announcement_date', cmd: 'announcement_date' }],
        TIME: null
    },
    company_database: {
        nonEntityes: ['company_name', 'company_type', 'website_url', 'employees', 'sector', 'industry', 'country', 'state', 'city', 'address', 'phone_number', 'company_desscription',
            'ir_section_link', 'pr_section_link', 'executives_section_link', 'analyst_coverage_link', 'events_section_link', 'language', 'start_date', 'end_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'start_date', cmd: 'start_date' }, { title: 'end_date', cmd: 'end_date' }],
        tickers: {
            DATE: ['trading_start_date', 'trading_end_date'],
            nonEntityes: ['ticker', 'exchange', 'security_category', 'trading_status']
        },
        ir_executives: {
            nonEntityes: ['ir_name', 'ir_desigantion', 'ir_phone_number', 'ir_email'],
            DATE: []
        }
    },
    company_database_update: {
        nonEntityes: ['company_name', 'website_url', 'employees', 'sector', 'industry', 'address', 'phone_number', 'company_desscription',
            'ir_section_link', 'pr_section_link', 'executives_section_link', 'analyst_coverage_link', 'events_section_link', 'language', 'start_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'start_date', cmd: 'start_date' }],
        ir_executives: {
            nonEntityes: ['ir_name', 'ir_desigantion', 'ir_phone_number', 'ir_email'],
            DATE: []
        }
    },
    add_ticker_information: {
        nonEntityes: ['company_name'],
        date: ['date'],
        time: ['time'],
        DATE: [],
        tickers : {
            DATE: ['trading_start_date','trading_end_date'],
            nonEntityes: ['ticker','exchange','security_category','trading_status']
        },
    },
    liquidation : {
        nonEntityes: [ 'time_zone','company_name','effective_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'effective_date', cmd: 'effective_date' }],
        TIME: null
    },
    bankruptcy: {
        nonEntityes: ['time_zone', 'bankruptcy_type', 'company_name', 'effective_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'effective_date', cmd: 'effective_date' }],
        TIME: null
    },
    company_name_change: {
        nonEntityes: ['time_zone', 'company_name', 'new_company_name', 'effective_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'effective_date', cmd: 'effective_date' }],
        ORG: [{ title: 'company_name', cmd: 'company_name' }, { title: 'new_company_name', cmd: 'new_company_name' }],
        TIME: null
    },
    exchange_ticker_change: {
        nonEntityes: ['time_zone', 'ticker', 'exchange', 'company_name', 'effective_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'effective_date', cmd: 'effective_date' }],
        TIME: null
    },
    delisted: {
        nonEntityes: ['time_zone', 'ticker', 'exchange', 'company_name', 'effective_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'effective_date', cmd: 'effective_date' }],
        TIME: null
    },
    head_quarters_change: {
        nonEntityes: ['time_zone', 'headquarters', 'state', 'city', 'company_name', 'effective_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'effective_date', cmd: 'effective_date' }],
        TIME: null
    },
    acquisition: {
        nonEntityes: ['time_zone', 'acquirer_company_name', 'target_company_name', 'effective_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'effective_date', cmd: 'effective_date' }],
        TIME: null,
        ORG: [{ title: 'acquirer_company_name', cmd: 'acquirer_company_name' }, { title: 'target_company_name', cmd: 'target_company_name' }, { title: 'new_company_name', cmd: 'new_company_name' }],
    },
    merger: {
        nonEntityes: ['time_zone', 'merged_company_name', 'effective_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'effective_date', cmd: 'effective_date' }],
        TIME: null,
        org: {
            ORG: ['merger_company_name'],
            nonEntityes: []
        },
        ORG: [{ title: 'merged_company_name', cmd: 'merged_company_name' }]
    },
    spin_off: {
        nonEntityes: ['time_zone', 'parent_company_name', 'effective_date'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'effective_date', cmd: 'effective_date' }],
        TIME: null,
        org: {
            ORG: ['spin_off_company_name'],
            nonEntityes: []
        },
        ORG: [{ title: 'parent_company_name', cmd: 'parent_company_name' }]
    },
    add_persons: {
        nonEntityes: ['email', 'description', 'gender', 'person_name', 'date_of_birth'],
        date: ['date'],
        time: ['time'],
        DATE: [{ title: 'date_of_birth', cmd: 'date_of_birth' }, { title: 'deceased_date', cmd: 'deceased_date' }],
        TIME: null,
        educations: {
            DATE: ['educations:start_date', 'educations:end_date'],
            nonEntityes: ['educational_institution', 'educational_qualification', 'description']
        },
        work_history: {
            nonEntityes: ['description', 'designation'],
            ORG: ['company_name'],
            DATE: ['work_history:start_date', 'work_history:end_date'],
        },
        PERSON: [{ title: 'person_name', cmd: 'person_name' }]
    },
    securities: {
        nonEntityes: ['ticker', 'exchange', 'security_category', 'trading_status', 'company_name', 'trading_start_date', 'trading_end_date'],
        DATE: [{ title: 'trading_start_date', cmd: 'trading_start_date' }, { title: 'trading_end_date', cmd: 'trading_end_date' }],
    },
    data_source: {
        nonEntityes: [],
        DATE: [],
    }

}

export const configEventTypes = [
    'analyst_or_investor_conference',
    'annual_general_meeting_conference',
    'earnings_announcement_release',
    'earnings_conference',
    'sales_or_revenue_release',
    'sales_or_revenue_conference',
    'corporate_conference',
    'guidance_conference',
    'special_or_m_and_a_conference',
    'management_update_release',
    'm_and_a_release',
    'earnings_release',
    'product_release',
    'other_releases',
    'forecasted_earnings_release_date',
    'earnings_release_date_change',
    'capital_markets_day',
    'r_and_d_day',
    'company_roadshow',
    'business_update_call',
    'board_meeting',
    'comp_store_sales_release',
    'index_change',
    'seminar',
    'summit_meeting',
    'work_shop',
    'forum',
    'share_buyback',
    'shareholder_meeting',
    'spinoff',
    'stock_split',
    'dividend_update',
    'dividend_suspended_or_resumed',
    'legal_or_lawsuit_update',
    'trade_show',
    'ipos',
    'secondary_offering',
    'guidance_update'
]

export const configEventTypesWithLable =
{
    'Analyst or Investor Conference': 'analyst_or_investor_conference',
    'Annual General Meeting Conference': 'annual_general_meeting_conference',
    'Earnings Announcement Release': 'earnings_announcement_release',
    'Earnings Conference': 'earnings_conference',
    'Sales or Revenue Release': 'sales_or_revenue_release',
    'Sales or Revenue Conference': 'sales_or_revenue_conference',
    'Corporate Conference': 'corporate_conference',
    'Guidance Conference': 'guidance_conference',
    'Special or M and A Conference': 'special_or_m_and_a_conference',
    'Management Update Release': 'management_update_release',
    'M and A Release': 'm_and_a_release',
    'Earnings Release': 'earnings_release',
    'Product Release': 'product_release',
    'Other Releases': 'other_releases',
    'Forecasted Earnings Release Date': 'forecasted_earnings_release_date',
    'Earnings Release Date Change': 'earnings_release_date_change',
    'Capital Markets Day': 'capital_markets_day',
    'R and D Day': 'r_and_d_day',
    'Company Roadshow': 'company_roadshow',
    'Business Update Conference': 'business_update_call',
    'Board Meeting': 'board_meeting',
    'Comp Store Sales Release': 'comp_store_sales_release',
    'Index Change': 'index_change',
    'Seminar': 'seminar',
    'Summit Meeting': 'summit_meeting',
    'Work Shop': 'work_shop',
    'Forum': 'forum',
    'Share Buyback': 'share_buyback',
    'Shareholder Meeting': 'shareholder_meeting',
    'Spinoff': 'spinoff',
    'Stock Split': 'stock_split',
    'Dividend Update': 'dividend_update',
    'Dividend Suspended or Resumed': 'dividend_suspended_or_resumed',
    'Legal or Lawsuit Update': 'legal_or_lawsuit_update',
    'Trade Show': 'trade_show',
    'Ipos': 'ipos',
    'Secondary Offering': 'secondary_offering',
    'Guidance Update': 'guidance_update'
}
export const eventsTypes =
{
    'analyst_or_investor_conference': 'Analyst or Investor Conference',
    'annual_general_meeting_conference': 'Annual General Meeting Conference',
    'earnings_announcement_release': 'Earnings Announcement Release',
    'earnings_conference': 'Earnings Conference',
    'sales_or_revenue_release': 'Sales or Revenue Release',
    'sales_or_revenue_conference': 'Sales or Revenue Conference',
    'corporate_conference': 'Corporate Conference',
    'guidance_conference': 'Guidance Conference',
    'special_or_m_and_a_conference': 'Special or M and A Conference',
    'management_update_release': 'Management Update Release',
    'm_and_a_release': 'M and A Release',
    'earnings_release': 'Earnings Release',
    'product_release': 'Product Release',
    'other_releases': 'Other Releases',
    'forecasted_earnings_release_date': 'Forecasted Earnings Release Date',
    'earnings_release_date_change': 'Earnings Release Date Change',
    'capital_markets_day': 'Capital Markets Day',
    'r_and_d_day': 'R and D Day',
    'company_roadshow': 'Company Roadshow',
    'business_update_call': 'Business Update Conference',
    'board_meeting': 'Board Meeting',
    'comp_store_sales_release': 'Comp Store Sales Release',
    'index_change': 'Index Change',
    'seminar': 'Seminar',
    'summit_meeting': 'Summit Meeting',
    'work_shop': 'Work Shop',
    'forum': 'Forum',
    'share_buyback': 'Share Buyback',
    'shareholder_meeting': 'Shareholder Meeting',
    'spinoff': 'Spinoff',
    'stock_split': 'Stock Split',
    'dividend_update': 'Dividend Update',
    'dividend_suspended_or_resumed': 'Dividend Suspended or Resumed',
    'legal_or_lawsuit_update': 'Legal or Lawsuit Update',
    'trade_show': 'Trade Show',
    'ipos': 'Ipos',
    'secondary_offering': 'Secondary Offering',
    'guidance_update': 'Guidance Update'
}

export const dateFields = ['announcement_date','event_date','registration_deadline','period_end_date','release_date','projected_release_date','revised_earnings_release_date','prior_earnings_release_date',
                                        'start_date','end_date','replay_beginning_date','replay_end_date','effective_date','event_start_date','event_end_date','modification_announcement_date','approval_date','buy_back_end_date','tender_expiration_date',
                                        'record_date','distribution_date','trade_date','approval_date','parent_company_trading_when_issued_from_date','parent_company_trading_when_issued_to_date','spin_off_company_trading_when_issued_from_date','spin_off_company_trading_when_issued_to_date',
                                        'revised_stock_trading_date','split_effective_date','ex_dividend_date','pay_date','suspended_or_resumed_date','class_action_start_date','class_action_end_date','filling_date','offering_date','closing_date','financial_date','quiet_period','lockup_period','motion_dead_line','rescheduled_event_date','cancelled_event_date',
                                        'rescheduled_event_end_date','rescheduled_event_start_date','rescheduled_end_date','rescheduled_start_date','trading_end_date','trading_start_date','date_of_birth','deceased_date','dismissed_date','resigned_date','retired_date','coverage_start_date','coverage_end_date'
                                    ];
export const timeFields = ['event_time','release_time','projected_release_time','revised_earnings_release_time','prior_earnings_release_time','start_time','end_time',
                                        'event_start_time','event_end_time','tender_expiration_time','rescheduled_event_time','rescheduled_end_time','rescheduled_start_time','rescheduled_event_start_time','rescheduled_event_end_time',
                                    ];
export const urlFields = ['live_webcast_url','replay_webcast_url','event_link','registration_link','schedule_link','lawsuit_link','lawfirm_url','prospectus_link','virtual_shareholder_meeting','website_url','pr_section_link','ir_section_link','executives_section_link','events_section_link','analyst_coverage_link','company_data_source_link'];

export const emailFields = ['email','plaintiff_email','ir_email','analyst_email','directors_email','officers_email','others_email']

export const personFields = ['ir_name','presenter_name','contact_person_name','person_name']

export const timezoneFields = ['time_zone','rescheduled_event_time_zone','rescheduled_time_zone','cancelled_event_time_zone'];

export const phoneFields = ['plaintiff_phone_no','phone_number','registration_phone','live_phone_us','replay_phone_us','live_phone_international','replay_phone_international','ir_phone_number','directors_phone_number','officers_phone_number',];

export const numbersFields = ['number_of_shares_for_sale','shares_offered','no_of_authorized_shares','low_end_price_range','high_end_price_range','purchase_price','live_passcode_us','live_passcode_international','replay_passcode_us','replay_passcode_international','registration_passcode','seminar_passcode','share_price', 'offer_amount','low_end_share_price','high_end_share_price','split_ratio','dividend_amount'];

export const orgFields = ['new_company_name','acquirer_company_name','target_company_name','company_name','company_name_added','company_name_removed','merger_company_name','merged_company_name','selected_company_name','coverage_company_name','selected_coverage_company_name','parent_company_name','spin_off_company_name']

export const conferences = [
    'annual_general_meeting_conference',
    'earnings_conference',
    'corporate_conference',
    'analyst_or_investor_conference',
    'sales_or_revenue_conference',
    'guidance_conference',
    'special_or_m_and_a_conference',
    'business_update_call',
    'board_meeting',
    'shareholder_meeting',
    'capital_markets_day',
    'r_and_d_day',
    'company_roadshow',
    'seminar',
    'summit_meeting',
    'work_shop',
    'forum',
    'trade_show'
]

